import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Delete } from '@mui/icons-material';

interface DeleteThreadDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  threadTitle: string;
}

const DeleteThreadDialog: React.FC<DeleteThreadDialogProps> = ({
  open,
  onClose,
  onDelete,
  threadTitle,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete();
      onClose();
    } catch (error) {
      console.error('Error deleting thread:', error);
      // Error handling could be improved with a toast notification
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Delete color="error" />
          <Typography variant="h6" component="div">
            Delete Chat Thread
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete this chat thread?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          <strong>Thread:</strong> {threadTitle}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This action will hide the thread from your chat history and will no longer be visible to you.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          disabled={loading}
          color="inherit"
        >
          Cancel
        </Button>
        <Button 
          onClick={handleDelete} 
          disabled={loading}
          variant="contained"
          color="error"
          startIcon={<Delete />}
        >
          {loading ? 'Deleting...' : 'Delete Thread'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteThreadDialog;
